// extracted by css-extract-rspack-plugin
export default {"container":"truncated-text__container___yqLjS","truncatedText":"truncated-text__truncatedText___S1F1F","wrapText":"truncated-text__wrapText___qCeQn"};